import { useEffect, useState } from 'react';

const LoadingBar = ({ 
    isLoading, 
    color = '#7C3AED', // Default to lilac
    height = '2px',
    duration = '1.5s',
    className = ''
}) => {
    const [progress, setProgress] = useState(0);
    const [opacity, setOpacity] = useState(0);

    useEffect(() => {
        let progressInterval;
        let fadeTimeout;

        if (isLoading) {
            setOpacity(1);
            // Reset progress when loading starts
            setProgress(0);
            
            // Animate progress from 0 to 90% while loading
            progressInterval = setInterval(() => {
                setProgress(prev => {
                    if (prev < 90) {
                        return prev + (90 - prev) * 0.1;
                    }
                    return prev;
                });
            }, 100);
        } else {
            // When loading completes, quickly fill to 100% and fade out
            setProgress(100);
            fadeTimeout = setTimeout(() => {
                setOpacity(0);
                setProgress(0);
            }, 200);
        }

        return () => {
            clearInterval(progressInterval);
            clearTimeout(fadeTimeout);
        };
    }, [isLoading]);

    return (
        <div 
            className={`fixed top-0 left-0 w-full z-50 ${className}`}
            style={{ height }}
        >
            <div 
                className="absolute top-0 left-0 h-full transition-all ease-out"
                style={{
                    width: `${progress}%`,
                    backgroundColor: color,
                    opacity,
                    transition: `width ${duration} ease-out, opacity 0.2s ease-out`,
                }}
            />
        </div>
    );
};

export default LoadingBar; 